import { BookOpen, Trophy } from "lucide-react";
import { MODALITIES, useModality } from "../context/ModalityContext";

const ICONS = { competition: Trophy, study: BookOpen };

export function ModalitySwitch({ compact = false, className = "" }) {
  const { modality, setModality } = useModality();
  return (
    <div
      role="radiogroup"
      aria-label="Modality"
      data-testid="modality-switch"
      data-modality={modality}
      className={`inline-flex border border-border ${compact ? "" : "w-full sm:w-auto"} ${className}`}
    >
      {MODALITIES.map((m) => {
        const Icon = ICONS[m.id];
        const on = modality === m.id;
        return (
          <button
            key={m.id}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => setModality(m.id)}
            data-testid={`modality-${m.id}`}
            title={m.desc}
            className={`inline-flex items-center justify-center gap-1.5 tracking-[0.2em] uppercase transition-colors ${compact ? "px-2.5 py-1.5 text-[9px]" : "flex-1 sm:flex-none px-4 py-2.5 text-[10px]"} ${
              on
                ? m.id === "study" ? "bg-sky-400/15 text-sky-300" : "bg-primary/15 text-phosphor"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon className={compact ? "w-3 h-3" : "w-3.5 h-3.5"} />
            {m.label}
          </button>
        );
      })}
    </div>
  );
}

export function StudyTag({ testid = "study-tag" }) {
  return (
    <span className="ml-2 px-2 py-0.5 border border-sky-400/60 text-sky-300 text-[9px] tracking-widest" data-testid={testid}>
      STUDY
    </span>
  );
}
